module.exports = __webpack_public_path__ + "delete.png?bf9794eeca3acca9ceb7351914fefbb5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.png
// module id = 657
// module chunks = 0 2 6 7 8 9 10